// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatafei } from "../../../icons/mono/build/icon-statafei.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatafeiIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatafei.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatafeiIcon.displayName = 'StatafeiIcon';
}

export default StatafeiIcon;